import { FC } from 'react'
import styles from 'components/features/pfm/PremiumOnlyIcon/PremiumOnlyIcon.styl'
import SvgIcon from 'components/atoms/SvgIcon'
import LockGradSvg from 'icons/lock-grad.svg?skip-svgo'

type PremiumOnlyIconProps = {
  isBlocked: boolean
}

export const PremiumOnlyIcon: FC<PremiumOnlyIconProps> = (props) => {
  const { isBlocked } = props

  if (!isBlocked) {
    return null
  }

  return (
    <SvgIcon
      src={ LockGradSvg }
      useDefaultViewBox
      className={ styles.premiumOnlyIcon }
    />
  )
}
